export function fontSize(designWidth, diyFontSize) {
    var dpr = window.devicePixelRatio;
    var scale = 1 / dpr;
    var metaEle = document.createElement('meta');
    metaEle.name = 'viewport';
    metaEle.content =
        'width=device-width,initial-scale=' +
            scale +
            ',maximum-scale=' +
            scale +
            ',minimum-scale=' +
            scale +
            ',user-scalable=no';
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(metaEle);
    var html = document.getElementsByTagName('html')[0];
    var clientSize = document.documentElement.clientWidth;
    if (typeof window.orientation === 'number' &&
        typeof window.onorientationchange === 'object') {
        var isLandscape = window.matchMedia('(orientation: landscape)').matches;
        if (isLandscape) {
            clientSize =
                document.documentElement.clientHeight *
                    (/(Android)/i.test(navigator.userAgent) ? 1.25 : 1);
        }
    }
    var result = (diyFontSize * clientSize) / designWidth;
    html.style.fontSize = result + 'px';
    return result;
}
export var updateOrientation = function () {
    var orientation;
    if (typeof window.orientation === 'number' &&
        typeof window.onorientationchange === 'object') {
        switch (window.orientation) {
            case 90:
            case -90:
                orientation = 'landscape';
                break;
            default:
                orientation = 'portrait';
        }
    }
    else {
        orientation =
            window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    }
    return orientation;
};
var ua = navigator.userAgent;
export var isOnIPhone = /(iPhone|iPad|iPod|iOS)/i.test(ua) ||
    (/Macintosh/i.test(ua) && ua.toLocaleLowerCase().indexOf('chrome') === -1);
/**
 * 判断当前设备类型  android  ios h5
 *
 */
export var checkDeviceType = function () {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var temp = '';
    if (isAndroid) {
        temp = 'android';
    }
    else if (isiOS) {
        temp = 'ios';
    }
    else {
        temp = 'h5';
    }
    return temp;
};
export var setNewsit = function (id) {
    var list = ['1001', '2001', '3001', '4001', '5200', '5000'];
    var flag = list.some(function (item) { return item === id; }) || Number(id) > 5200;
    return flag;
};
export var setNewsit2 = function (id) {
    var list = ['1001', '2001', '3001', '4001', '5200', '5000'];
    var flag = list.some(function (item) { return item === id; }) || Number(id) > 5200;
    return !flag;
};
export var getSITEID = function (id) {
    id = String(id);
    // 异常类型处理
    var siteidstauts = id === '1001' || id === '2001' || id === '3001' || id === '4001';
    if (!siteidstauts) {
        id = '1001';
    }
    return id;
};
